export default __webpack_public_path__ + "static/media/Mumbai.480e831f.png";